import { useEffect } from 'react';
import { useGetCurrentUserId } from '@wwe-portal/web/providers/stores/auth-store';
import * as gtm from './tracking';

export const GtmInitiator = () => {
  const userId = useGetCurrentUserId();

  useEffect(() => {
    if (userId) gtm.setUserId(userId);
  }, [userId]);

  return null;
};
